import productSliders from "../sliders/product-slider";
import changeVariant from "./change-variant";
import colorDescriptionChange from "../modules/color-description";

// Initialise Default options
if (
  window.location.pathname.includes("product") &&
  window.location.search.length > 0
) {
  handleDefaultOption();
} else if (window.location.pathname.includes("product")) {
  handleDisabledOptions();
}

export function handleDefaultOption(variantId = null) {
  const variantParam = window.location.search
    .substring(1)
    .split("&")
    .find((param) => param.includes("variant="));


  const defaultVariantId =
    variantId || (variantParam && variantParam.split("=")[1]);

  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";

  if (defaultVariantId) {
    let defaultValue = [];
    $(".js-main-select option").each((i, elem) => {
      if ($(elem).val() == defaultVariantId) {
        defaultValue = $(elem).attr("data-variant-options").split(":");
      }
    });

    if ($(`${quickshopSelector} .js-color-text`).length > 0) {
      colorDescriptionChange(defaultValue[0]);
      $(`${quickshopSelector} .js-color-text`).text(
        // Capitalise first letter of each word (regex for conciseness)
        defaultValue[0].replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
          letter.toUpperCase()
        )
      );
    }

    $(`${quickshopSelector} .js-select-options input`).removeClass(
      "selected-option"
    );

    $(`${quickshopSelector} .js-select-options`).each((i, fieldGroup) => {
      $(fieldGroup)
        .find("input")
        .each((i, input) => {
          if (defaultValue.includes($(input).val())) {
            $(input).addClass("selected-option");
          }
        });
    });

    handleDisabledOptions();
  }
}

export default function changeOptions() {
  // radio buttons
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";

  $(`${quickshopSelector} .product__body .js-select-options input`).on(
    "click",
    function () {
      const $this = $(this);
      const selectedOptionName = $this.data("name");

      $this
        .parents(".list-color-swatches")
        .prev()
        .find("span:first")
        .html(selectedOptionName);

      $(".js-select-options--item input").removeClass("selected-option");

      $this.addClass("selected-option");

      changeSelectedOptions();
    }
  );

  $(`${quickshopSelector} .js-select-options input`).on("click", function () {
    const $this = $(this);
    const selectedOptionName = $this.data("name");
    const selectedOptionVal = $this.val();
    const parentElement = $this.parents("li");
    const inputName = $this.attr("name");

    if (inputName === "color-swatches") {
      colorDescriptionChange(selectedOptionVal);
    }

    $this.addClass("selected-option");
    parentElement.siblings().find("input").removeClass("selected-option");

    let selectedOption = [];
    $(`${quickshopSelector} .js-select-options`).each((i, group) => {
      selectedOption.push($(group).find("input.selected-option").val());
    });

    const optionString = selectedOption.join(":");
    let variantId;

    if (
      $(
        `${quickshopSelector} .js-main-select option[data-variant-options="${optionString}"]`
      ).length > 0
    ) {
      variantId = $(
        `${quickshopSelector} .js-main-select option[data-variant-options="${optionString}"]`
      ).val();
    } else {
      variantId = $(
        `${quickshopSelector} .js-main-select option[data-variant-options^="${selectedOption[0]}"]`
      ).val();
    }

    // Update the max quantity level that is set on the
    // quantity input
    const variantData = document.getElementById("variant_data");

    if (variantData) {
      const data = JSON.stringify(JSON.parse(variantData.textContent));
      const variants = JSON.parse(data);

      const variant = variants.find(
        (variant) => variant.id === parseInt(variantId)
      );

      if (variant) {
        // Set the hidden select
        const select = document.querySelector(".js-main-select");

        if (select) {
          const options = Array.from(select.options);

          options.forEach((option, i) => {
            if (parseInt(option.value) === variant.id) select.selectedIndex = i;
          });
        }
      }
    }

    if ($this.parents(".list-color-swatches").length > 0) {
      $(`${quickshopSelector} .js-color-text`).text(selectedOptionName);
      productSliders(true, false, selectedOptionVal, false, false, variantId);
    }

    if ($this.parents(".list-radio-buttons").length > 0) {
      const currentSwatch = $(
        `${quickshopSelector} .list-color-swatches .selected-option`
      ).val();
      productSliders(
        true,
        false,
        currentSwatch,
        false,
        selectedOptionVal,
        variantId
      );
    }

    changeSelectedOptions();

    changeVariant();
  });

  //select dropdown
  $(`${quickshopSelector} .js-select-dropdown select`).on(
    "change",
    function () {
      const $this = $(this);
      const $selectedOption = $this.find("option:selected");
      const selectedOptionVal = $selectedOption.val();

      $selectedOption
        .addClass("selected-option")
        .siblings()
        .removeClass("selected-option");

      $this.val(selectedOptionVal);

      changeSelectedOptions();

      changeVariant();
    }
  );
}

export function changeSelectedOptions() {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";

  const $selectedOptions = $(`${quickshopSelector} .selected-option`);
  let allOptionsString = [];

  $selectedOptions.each(function () {
    const selectedOption = $(this);
    const selectedOptionVal = selectedOption.val();

    // avoid adding values from selectric select
    if (selectedOption.parents(".selectric-scroll").length > 0) {
      return;
    }

    allOptionsString.push(selectedOptionVal);
  });

  $(`${quickshopSelector} .js-selected-options`).val(
    allOptionsString.join(":")
  );

  handleDisabledOptions();
}

if ($(".template-product").length > 0) {
  changeOptions();
}

export function handleDisabledOptions() {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";

  const selectedOptionDataArr = [];

  document
    .querySelectorAll(`${quickshopSelector} .js-main-select option`)
    .forEach((item) => selectedOptionDataArr.push(item.dataset));

  const groupedOptions = {};

  selectedOptionDataArr.map((stringMap, i) => {
    const optionOne = stringMap[Object.keys(stringMap)[0]];
    groupedOptions[optionOne] = [];
  });

  selectedOptionDataArr.map((stringMap, i) => {
    const selectedOptions = [];
    for (let i = 0; i < Object.keys(stringMap).length; i++) {
      const key = Object.keys(stringMap)[i];
      if (key === "optionBreak") {
        break;
      }
      selectedOptions.push(stringMap[key]);
    }

    if (selectedOptions.length === 3) {
      groupedOptions[selectedOptions[0]].push({
        option1: selectedOptions[1],
        option2: selectedOptions[2],
      });
    } else {
      groupedOptions[selectedOptions[0]].push({ option1: selectedOptions[1] });
    }
  });

  const activeOption = $(`${quickshopSelector} .selected-option`).val();

  const currentGroup = groupedOptions[activeOption];

  let selectedOptions = [];
  $(`${quickshopSelector} .form__body .list-radio-buttons`).each((i, group) => {
    const handleStates = () => {
      $(group)
        .find("input")
        .each((_, input) => {
          const groupHasValue = currentGroup
            ? currentGroup.some((i) => {
                if (i.option2) {
                  return (
                    i.option1 === $(input).val() || i.option2 === $(input).val()
                  );
                }
                return i.option1 === $(input).val();
              })
            : false;

          // If the option isn't available, disable it and remove any active classes
          if (!groupHasValue) {
            $(input).prop("disabled", true);
            $(input).prop("checked", false);
            $(input).removeClass("selected-option");
          } else {
            $(input).prop("disabled", false);
          }
        });

      const $enabledInputs = $(group).find(":enabled");
      // If we've gone from disabled options to enabled options, handle the first instance
      if (
        $enabledInputs.length > 0 &&
        $(group).find(".selected-option").length === 0
      ) {
        const $firstAvailable = $(group).find(":enabled").first();

        $firstAvailable.prop("checked", true);
        $firstAvailable.addClass("selected-option");

        $(".form__body .list-radio-buttons")
          .find(":checked")
          .each((i, item) => {
            selectedOptions.push($(item).val());
          });

        if (selectedOptions.length > 0) {
          $(".js-selected-options").val(
            `${activeOption}:${selectedOptions.join(":")}`
          );
        } else {
          $(".js-selected-options").val(`${activeOption}`);
        }
      }
    };

    // We don't want to handle the states for the first group
    // We also need to handle products opened by the quickshop
    if ($(".quickshop.is-open").length > 0) {
      if (
        $(".quickshop.is-open .product__body .list-color-swatches").length > 0
      ) {
        handleStates();
      } else if (i > 0) {
        handleStates();
      }
    } else {
      if ($(".product__body .list-color-swatches").length > 0) {
        handleStates();
      } else if (i > 0) {
        handleStates();
      }
    }
  });
}
